<div class="welcome-state" *ngIf="!currentThreadId && !loading && !inFloatingPanel">
    <div class="welcome-content">
        <div class="ai-avatar">
            <svg class="platfio-logo" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <!-- Single clean circle with subtle animation -->
                <circle cx="16" cy="16" r="8" 
                        fill="#15cdff" 
                        opacity="0.8">
                    <animate attributeName="opacity" 
                             values="0.8;1;0.8" 
                             dur="3s" 
                             repeatCount="indefinite"/>
                </circle>
            </svg>
        </div>
        
        <!-- Welcome Text with Business Name -->
        <div class="welcome-text">
            <span>Let's chat about </span>
            <span *ngIf="contextUserObject?.businessName" class="business-name">
                {{contextUserObject.businessName}}
            </span>
            <span *ngIf="!contextUserObject?.businessName" class="business-name">your business</span>
        </div>

        <!-- Welcome Subtitle -->
        <!-- <div class="welcome-subtitle">
            Choose a starter prompt below or type your own question to begin our conversation.
        </div> -->

        <!-- Context Chip (if applicable) -->
        <div class="context-chip" *ngIf="contextUserObject?.businessContext">
            <i class="fas fa-info-circle"></i>
            <span>{{ contextUserObject.businessContext }}</span>
        </div>

        <!-- Shortcuts Guide -->
        <div class="shortcuts-guide">
            <div class="shortcut-item" (click)="demonstrateShortcut('agent')">
                <div class="shortcut-key">&#64;</div>
                <div class="shortcut-info">
                    <div class="shortcut-label">Select Agent</div>
                </div>
                <div class="shortcut-arrow">
                    <i class="fas fa-arrow-right"></i>
                </div>
            </div>

            <div class="shortcut-item" (click)="demonstrateShortcut('context')">
                <div class="shortcut-key">#</div>
                <div class="shortcut-info">
                    <div class="shortcut-label">Add Context</div>
                </div>
                <div class="shortcut-arrow">
                    <i class="fas fa-arrow-right"></i>
                </div>
            </div>

            <div class="shortcut-item" (click)="demonstrateShortcut('config')">
                <div class="shortcut-key">+</div>
                <div class="shortcut-info">
                    <div class="shortcut-label">Chat Settings</div>
                </div>
                <div class="shortcut-arrow">
                    <i class="fas fa-arrow-right"></i>
                </div>
            </div>

            <div class="shortcut-item" (click)="demonstrateShortcut('prompts')">
                <div class="shortcut-key">/</div>
                <div class="shortcut-info">
                    <div class="shortcut-label">Quick Prompts</div>
                </div>
                <div class="shortcut-arrow">
                    <i class="fas fa-arrow-right"></i>
                </div>
            </div>

            <div class="shortcuts-footer">
                <small>
                    <i class="fas fa-lightbulb"></i>
                    <span>Click any shortcut above to see it in action</span>
                </small>
            </div>
        </div>
    </div>
</div>
